/**
 * Module dependencies.
 */

import kebabCase from 'lodash/kebabCase';

/**
 * Build a URL segment from a category display name (e.g. "Glazed Wall Tiles" → "glazed-wall-tiles").
 */

export function categoryNameToSlug(name: string): string {
  return kebabCase(name);
}
